<template>
  <article class="landing-page">

    <landing-header></landing-header>
    <landing-hero id="inicio"></landing-hero>
    <landing-testimonials id="depoimentos"></landing-testimonials>
    <landing-clients id="clientes"></landing-clients>
    <landing-how-we-work id="como-trabalhamos"></landing-how-we-work>
    <landing-office id="escritorio"></landing-office>
    <landing-github id="open-source"></landing-github>
    <landing-workable id="vagas"></landing-workable>

  </article>
</template>

<style lang="less">
  @import (reference) '../assets/styles/references';
  .landing-page {
    padding-top: @lg-spacer;
    @media @phone {
      padding-top: 0;
    }
  }
  .section-title {
    position: relative;
    font-weight: @font-weight-light;
    text-transform: uppercase;
    font-style: @xl-font-size;
    line-height: @xl-font-size + 1.5em;
    color: @blue-2;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -@sm-spacer;
      width: 43px;
      height: 4px;
      background-color: @light-blue-2;
      border-radius: 2px;
    }
  }
</style>

<script>
  import LandingHeader from '../components/LandingHeader'
  import LandingHero from '../components/LandingHero'
  import LandingTestimonials from '../components/LandingTestimonials'
  import LandingClients from '../components/LandingClients'
  import LandingHowWeWork from '../components/LandingHowWeWork'
  import LandingOffice from '../components/LandingOffice'
  import LandingGithub from '../components/LandingGithub'
  import LandingWorkable from '../components/LandingWorkable'

  export default {
    components: {
      LandingHeader,
      LandingHero,
      LandingTestimonials,
      LandingOffice,
      LandingClients,
      LandingHowWeWork,
      LandingGithub,
      LandingWorkable
    }
  }
</script>



// WEBPACK FOOTER //
// Landing.vue?5de96208